import { apiGet, apiPatch, apiPost } from './client';

export type Acquirer = {
  id: string;
  name: string;
  provider: 'payok';
  enabled: boolean;
  isDefault: boolean;
  providerMerchantId: string | null;
  baseUrl: string | null;
  orderCreatePath: string | null;
  orderQueryPath: string | null;
  disbursementCreatePath: string | null;
  paymentMethodCode: string | null;
  countryCode: string | null;
  currency: string | null;
  language: string | null;
  depositNotificationUrl: string | null;
  disbursementNotificationUrl: string | null;
  returnUrl: string | null;
  transpayPublicKey: string | null;
  providerPublicKey: string | null;
  hasPrivateKey: boolean;
  createdAt: string;
  updatedAt: string;
};

export type AcquirerInput = {
  name?: string;
  provider?: 'payok';
  enabled?: boolean;
  isDefault?: boolean;
  providerMerchantId?: string | null;
  baseUrl?: string | null;
  orderCreatePath?: string | null;
  orderQueryPath?: string | null;
  disbursementCreatePath?: string | null;
  paymentMethodCode?: string | null;
  countryCode?: string | null;
  currency?: string | null;
  language?: string | null;
  depositNotificationUrl?: string | null;
  disbursementNotificationUrl?: string | null;
  returnUrl?: string | null;
  /** Accepts either bare base64 (provider delivery form) or full PEM block. */
  providerPublicKey?: string | null;
};

export type KeyResult = { pem: string; sha256: string };

export const acquirersApi = {
  list: () => apiGet<{ data: Acquirer[] }>('/api/acquirers').then((r) => r.data),
  get: (id: string) => apiGet<{ data: Acquirer }>(`/api/acquirers/${id}`).then((r) => r.data),
  create: (input: AcquirerInput) =>
    apiPost<{ data: Acquirer; transpayPublicKey: KeyResult }>('/api/acquirers', input),
  update: (id: string, input: AcquirerInput) =>
    apiPatch<{ data: Acquirer }>(`/api/acquirers/${id}`, input).then((r) => r.data),
  rotateKeypair: (id: string) =>
    apiPost<{ data: Acquirer; transpayPublicKey: KeyResult; notice: string }>(
      `/api/acquirers/${id}/rotate-keypair`,
    ),
  setDefault: (id: string) =>
    apiPost<{ data: Acquirer }>(`/api/acquirers/${id}/set-default`).then((r) => r.data),
};
